/**
 * Toast slice — prototype `toast()` (line 1683).
 *
 * Every prototype toast string is preserved verbatim by the actions that fire
 * them; the only additions are the failure toasts `mutate()` needs, which the
 * prototype never had because it could not fail (ARCHITECTURE §5.5).
 */

import type { StateCreator } from 'zustand';

import type { QdStore } from '../types.ts';

export interface Toast {
  id: string;
  msg: string;
  bd: string;
}

export const TOAST_MS = 2600;

export interface ToastsSlice {
  toasts: Toast[];
  toast: (msg: string, err?: boolean) => void;
  dismissToast: (id: string) => void;
}

let seq = 0;

export const createToastsSlice: StateCreator<QdStore, [], [], ToastsSlice> = (set) => ({
  toasts: [],

  toast: (msg, err) => {
    seq += 1;
    const id = 't' + Date.now() + '_' + seq;
    set((s) => ({ toasts: [...s.toasts, { id, msg, bd: err ? 'var(--acc2)' : 'var(--acc)' }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), TOAST_MS);
  },

  dismissToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
});
